function getObjectWithoutSensitiveData (obj, depth = 3) {
  return Object.keys(obj).reduce(function (objWithoutSensitiveData, key) {
    // If it's an object, go deeply and see if they contain any sensitive data
    const value = obj[key]

    if (value && typeof value === 'object' && !Array.isArray(value) && depth > 0) {
      objWithoutSensitiveData[key] = getObjectWithoutSensitiveData(value, depth - 1)
      return objWithoutSensitiveData
    }

    // If it's an array, check each element and see if they contain any sensitive data
    if (value && Array.isArray(value) && depth > 0) {
      objWithoutSensitiveData[key] = value.map(function (val) {
        if (val && typeof val === 'object' && !Array.isArray(val)) {
          return getObjectWithoutSensitiveData(val, depth - 1)
        } // TODO nested arrays
        return val
      })
      return objWithoutSensitiveData
    }

    // Check if the key is contain potential sensitive data
    if (!/secret|password|pw/gi.test(key)) {
      objWithoutSensitiveData[key] = value
    } else {
      console.warn(`object with keys: ${Object.keys(obj)} has potential sensitive data `)
    }
    return objWithoutSensitiveData
  }, {})
}

export function stringifyObjectUtil (value) {
  try {
    if (!value) {
      return ''
    }
    if (value instanceof Error) {
      return JSON.stringify(value, Object.getOwnPropertyNames(value))
    }
    if (Array.isArray(value)) {
      return JSON.stringify(value)
    }
    if (typeof value === 'object' && value.constructor === Object) {
      const valueWithoutSensitiveData = getObjectWithoutSensitiveData(value)
      return JSON.stringify(valueWithoutSensitiveData)
    }
    return value.toString()
  } catch (error) {
    console.error('an error occurred trying to stringify: ', value)
    return ''
  }
}

export function safeStringifyObjectUtil (object) {
  if (typeof object !== 'object') {
    return ''
  }
  return JSON.stringify(object || {})
}
